import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore(
  'authStore',
  () => {
    let _token = ref(null)
    let _user = ref(null)
    let _roles = ref(null)

    const setToken = (userToken) => {
      _token.value = userToken
    }

    const setUser = (user) => {
    _user.value = user
    }

    const setRoles = (roles) => {
    _roles.value = roles
    }

    const logout = () =>{
      _roles.value = null
      _token.value = null
      _user.value = null
    }

    return {
      _token,
      _user,
      _roles,
      setToken,
      setUser,
      setRoles,
      logout,
    }
  },
  {
    persist: true,
  }
)
